import MemberQuoteBlock from './MemberQuoteBlock'

export default MemberQuoteBlock
